import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

export function getInitials(firstName?: string, lastName?: string): string {
  const f = (firstName || '').trim().charAt(0);
  const l = (lastName || '').trim().charAt(0);
  return `${f}${l}`.toUpperCase() || '?';
}

export function getFullName(firstName?: string, lastName?: string): string {
  return [firstName, lastName].filter(Boolean).join(' ') || 'ללא שם';
}

export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

const AVATAR_COLORS = [
  '#C9A84C', '#2A7B88', '#3B82F6', '#22C55E', '#F59E0B',
  '#EF4444', '#8B5CF6', '#06B6D4', '#F97316', '#EC4899',
];

export function getColorForString(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function debounce<T extends (...args: unknown[]) => unknown>(
  fn: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
}

export const ORG_STATUS_LABELS: Record<string, string> = {
  active:    'פעיל',
  inactive:  'לא פעיל',
  suspended: 'מושעה',
};

export const SUB_STATUS_LABELS: Record<string, string> = {
  active:    'פעיל',
  trial:     'ניסיון',
  suspended: 'מושעה',
  cancelled: 'בוטל',
};

export const SUB_PLAN_LABELS: Record<string, string> = {
  basic:      'בייסיק',
  pro:        'פרו',
  enterprise: 'אנטרפרייז',
};

export const INTEGRATION_STATUS_LABELS: Record<string, string> = {
  active:   'פעיל',
  inactive: 'לא פעיל',
  pending:  'ממתין',
};

export function hebrewLabel(value: string, map: Record<string, string>): string {
  return map[value] ?? value;
}
